import { ReactElement } from 'react';

import adminPage from '../../../hoc/adminPage';
import { AdminLoginView } from '../../../views/AdminLoginView';

function AdminAnonymousPage(): ReactElement {
  return (
    <div id="AdminAnonymousPage" className="admin-anonymous-page">
      <AdminLoginView />
    </div>
  );
}

export default adminPage(AdminAnonymousPage);
